import { Controller } from '@hotwired/stimulus'
import { visit } from '@hotwired/turbo'

// odświeża stronę co interval ms (Turbo morph - bez mrugania i utraty przewinięcia), tylko gdy karta jest widoczna
export default class extends Controller {
  static values = { interval: { type: Number, default: 60000 } }

  connect() {
    this.timer = setInterval(() => {
      if (document.visibilityState === 'visible') visit(window.location.href, { action: 'replace' })
    }, this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
